















































































































































































































































































































































































































import { Component, Vue } from "vue-property-decorator";
import { SurveyForm, JsonObject } from "@/models/SurveyForm";
import { ItemTypes, Option, SurveyItem } from "@/models/SurveyItem";
import draggable from "vuedraggable";
import {
  findTextOfTargetLanguage,
  languages,
  SurveyText
} from "@/models/SurveyText";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import ValidationErrorDialog from "@/components/ValidationErrorDialog.vue";
import crypto from "crypto";
import moment from "moment";
import { version } from "../../package.json";

Component.registerHooks(["beforeRouteLeave"]);
@Component({
  components: {
    draggable,
    ValidationProvider,
    ValidationObserver,
    ValidationErrorDialog
  }
})
export default class SurveyEditor extends Vue {
  defaultLanguage: Readonly<{ lang: languages; text: string }> = {
    lang: "ja",
    text: "日本語"
  };
  surveyForm: SurveyForm = new SurveyForm(
    "",
    "",
    "",
    "",
    [new SurveyText(this.defaultLanguage.lang, "")],
    [new SurveyText(this.defaultLanguage.lang, "")],
    [new SurveyText(this.defaultLanguage.lang, this.defaultLanguage.text)],
    "AQS_QA",
    true,
    []
  );
  allowFileEextension: Readonly<string[]> = ["json"];
  candidateLanguages: { lang: languages; text: string; selected: boolean }[] = [
    { lang: "en", text: "English（英語）", selected: false },
    { lang: "zh-CN", text: "中文（简体字）", selected: false },
    { lang: "zh-TW", text: "中文（繁体字）", selected: false },
    { lang: "ko", text: "한국어（ハングル）", selected: false },
    { lang: "vi", text: "Tiếng việt（ベトナム語）", selected: false },
    { lang: "ti", text: "Tagalog（タガログ語）", selected: false },
    { lang: "th", text: "ภาษาไทย（タイ語）", selected: false },
    { lang: "pt", text: "Português（ポルトガル語）", selected: false },
    { lang: "bn", text: "বাঙ্গালি（ベンガル語）", selected: false }
  ];
  targetEditingLanguage = {
    lang: this.defaultLanguage.lang,
    text: this.defaultLanguage.text
  };
  targetDeletingLanguage = {
    lang: this.defaultLanguage.lang,
    text: this.defaultLanguage.text
  };
  deleteLanguageDialog = false;
  showSurveyValidationErrorDialog = false;
  showQRValidationErrorDialog = false;
  showSidebar = false;
  surveyItemNumValidationErrorMsg = "";
  prevSurveyId = "";
  errorValidateLanguages: Set<string> = new Set();
  typeItems: {
    display: string;
    type: ItemTypes;
  }[] = [
    {
      display: "文字列",
      type: "st"
    },
    {
      display: "メールアドレス",
      type: "em"
    },
    {
      display: "ラジオボタン",
      type: "rd"
    },
    {
      display: "チェックボックス",
      type: "cb"
    },
    {
      display: "日付(YYYY-MM-DD)",
      type: "dt"
    },
    {
      display: "セレクトボックス",
      type: "sl"
    },
    {
      display: "テキストエリア",
      type: "ta"
    },
    {
      display: "国",
      type: "cs"
    },
    {
      display: "数値",
      type: "nb"
    }
  ];
  version!: string;

  created() {
    /** 編集の戻るボタン抑制(ただし、ブラウザの不正対策により発動しない事あり) */
    window.addEventListener("beforeunload", this.confirmSave);
    this.version = version;
  }

  destroyed() {
    window.removeEventListener("beforeunload", this.confirmSave);
  }

  /** 編集の戻るボタン抑制(ただし、ブラウザの不正対策により発動しない事あり) */
  confirmSave(event: BeforeUnloadEvent) {
    event.preventDefault();
    event.returnValue = "";
  }

  /* eslint-disable  @typescript-eslint/no-explicit-any */
  isDefined(value: any): boolean {
    return value !== undefined && value !== null;
  }

  getTitle() {
    return findTextOfTargetLanguage(
      this.surveyForm.title,
      this.targetEditingLanguage.lang
    );
  }

  getDetail() {
    return findTextOfTargetLanguage(
      this.surveyForm.details,
      this.targetEditingLanguage.lang
    );
  }

  getDisplayName(surveyItem: SurveyItem) {
    return findTextOfTargetLanguage(
      surveyItem.displayName,
      this.targetEditingLanguage.lang
    );
  }

  getUnitsValue(surveyItem: SurveyItem) {
    return findTextOfTargetLanguage(
      surveyItem.units,
      this.targetEditingLanguage.lang
    );
  }

  getOptionValue(option: Option) {
    return findTextOfTargetLanguage(
      option.value,
      this.targetEditingLanguage.lang
    );
  }

  getSurveyItemIds() {
    return this.surveyForm.surveyItems.map(item => item.id);
  }

  changeTitle(text: string) {
    const title = this.surveyForm.title.find(
      v => v.lang === this.targetEditingLanguage.lang
    );
    if (title) {
      title.text = text;
    } else {
      this.surveyForm.title.push(
        new SurveyText(this.targetEditingLanguage.lang, text)
      );
    }
  }

  changeDetail(text: string) {
    const detail = this.surveyForm.details.find(
      v => v.lang === this.targetEditingLanguage.lang
    );
    if (detail) {
      detail.text = text;
    } else {
      this.surveyForm.details.push(
        new SurveyText(this.targetEditingLanguage.lang, text)
      );
    }
  }

  changeDisplayName(surveyItem: SurveyItem, event: string) {
    const displayName = surveyItem.displayName.find(
      v => v.lang === this.targetEditingLanguage.lang
    );
    if (displayName) {
      displayName.text = event;
    } else {
      surveyItem.displayName.push(
        new SurveyText(this.targetEditingLanguage.lang, event)
      );
    }
  }

  changeTab(event: number) {
    this.targetEditingLanguage.lang = this.surveyForm.langs[event].lang;
    this.targetEditingLanguage.text = this.surveyForm.langs[event].text;
  }

  changeRulesMax(surveyItem: SurveyItem, value: string) {
    const num = parseInt(value);
    const min = 1;
    if (Number.isNaN(num) || num < min) {
      surveyItem.rules.max = min;
    } else {
      surveyItem.rules.max = num;
    }
  }

  clickTabCloseButton(lang: languages, text: string) {
    this.targetDeletingLanguage = { lang: lang, text: text };
    this.deleteLanguageDialog = true;
  }

  deleteLanguage(lang: languages) {
    this.surveyForm.title = this.surveyForm.title.filter(v => v.lang !== lang);
    this.surveyForm.details = this.surveyForm.details.filter(
      v => v.lang !== lang
    );
    this.surveyForm.langs = this.surveyForm.langs.filter(v => v.lang !== lang);
    this.surveyForm.surveyItems.forEach(item => {
      item.displayName = item.displayName.filter(v => v.lang !== lang);
      item.options.forEach(
        opt => (opt.value = opt.value.filter(v => v.lang !== lang))
      );
      item.units = item.units.filter(v => v.lang !== lang);
    });
    const targetLanguage = this.candidateLanguages.find(v => v.lang === lang);
    if (targetLanguage) {
      targetLanguage.selected = false;
    }
    this.deleteLanguageDialog = false;
  }

  addLanguage(lang: languages, text: string) {
    this.surveyForm.title.push(new SurveyText(lang, ""));
    this.surveyForm.langs.push(new SurveyText(lang, text));
    this.surveyForm.details.push(new SurveyText(lang, ""));
    this.surveyForm.surveyItems.forEach(item => {
      item.displayName.push(new SurveyText(lang, ""));
      item.options.forEach(opt => opt.value.push(new SurveyText(lang, "")));
      item.units.push(new SurveyText(lang, ""));
    });
    const targetLanguage = this.candidateLanguages.find(v => v.lang === lang);
    if (targetLanguage) {
      targetLanguage.selected = true;
    }
  }

  isDisabledAddLanguageButton() {
    return this.candidateLanguages.find(v => v.selected === false)
      ? false
      : true;
  }

  addItem(
    selectType:
      | "st"
      | "em"
      | "rd"
      | "cb"
      | "dt"
      | "sl"
      | "ta"
      | "cs"
      | "nb"
      | "error"
  ) {
    this.surveyItemNumValidationErrorMsg = "";
    if (selectType === "rd" || selectType === "cb" || selectType === "sl") {
      this.surveyForm.surveyItems.push(
        new SurveyItem(
          selectType,
          String(this.surveyForm.surveyItems.length + 1),
          this.surveyForm.langs.map(v => new SurveyText(v.lang, "")),
          "",
          [
            new Option(
              "1",
              this.surveyForm.langs.map(v => new SurveyText(v.lang, "")),
              false
            )
          ],
          [],
          false,
          {
            required: true,
            max: 50
          }
        )
      );
    } else if (selectType === "nb") {
      this.surveyForm.surveyItems.push(
        new SurveyItem(
          selectType,
          String(this.surveyForm.surveyItems.length + 1),
          this.surveyForm.langs.map(v => new SurveyText(v.lang, "")),
          "",
          [],
          this.surveyForm.langs.map(v => new SurveyText(v.lang, "")),
          false,
          {
            required: true,
            max: 50
          }
        )
      );
    } else {
      this.surveyForm.surveyItems.push(
        new SurveyItem(
          selectType,
          String(this.surveyForm.surveyItems.length + 1),
          this.surveyForm.langs.map(v => new SurveyText(v.lang, "")),
          "",
          [],
          [],
          false,
          {
            required: true,
            max: selectType == "dt" ? 10 : 50
          }
        )
      );
    }
  }

  deleteItem(index: number) {
    this.surveyForm.surveyItems = this.surveyForm.surveyItems
      .filter((_, i) => i !== index)
      .map((item, i) => {
        item.id = String(i + 1);
        return item;
      });
  }

  forwardItem(index: number) {
    if (index === 0) {
      return;
    }
    const targetItem = this.surveyForm.surveyItems[index];
    const deletedItems = this.surveyForm.surveyItems.filter(
      (_, i) => i !== index
    );
    deletedItems.splice(index - 1, 0, targetItem);
    this.surveyForm.surveyItems = deletedItems.map((item, idx) => {
      item.id = String(idx + 1);
      return item;
    });
  }

  backwardItem(index: number) {
    if (index === this.surveyForm.surveyItems.length - 1) {
      return;
    }
    const targetItem = this.surveyForm.surveyItems[index];
    const deletedItems = this.surveyForm.surveyItems.filter(
      (_, i) => i !== index
    );
    deletedItems.splice(index + 1, 0, targetItem);
    this.surveyForm.surveyItems = deletedItems.map((item, idx) => {
      item.id = String(idx + 1);
      return item;
    });
  }

  addOption(surveyItem: SurveyItem) {
    if (!surveyItem.options) {
      surveyItem.options = [];
    }
    surveyItem.options.push({
      id: String(surveyItem.options.length + 1),
      value: this.surveyForm.langs.map(v => new SurveyText(v.lang, "")),
      isTextArea: false
    });
  }

  updateOptionTextArea(
    surveyItem: SurveyItem,
    isChecked: boolean,
    index: number
  ) {
    surveyItem.options[index].isTextArea = isChecked ?? false;
  }

  dragItem() {
    this.surveyForm.surveyItems = this.surveyForm.surveyItems.map(
      (item, idx) => {
        item.id = String(idx + 1);
        return item;
      }
    );
  }

  inputOptionValue(surveyItem: SurveyItem, event: string, index: number) {
    const optionValue = surveyItem.options[index].value.find(
      v => v.lang === this.targetEditingLanguage.lang
    );
    if (optionValue) {
      optionValue.text = event;
    } else {
      surveyItem.options[index].value.push(
        new SurveyText(this.targetEditingLanguage.lang, event)
      );
    }
    // 最大桁数を入力
    surveyItem.rules.max = surveyItem.options
      .map(opt => opt.value.map(v => v.text.length))
      .reduce((newArray, elem) => newArray.concat(elem), []) // convert number[][] to number[]
      .reduce((a, b) => (a > b ? a : b));
    this.$forceUpdate();
  }

  inputUnitsValue(surveyItem: SurveyItem, event: string) {
    const UnitsValue = surveyItem.units.find(
      v => v.lang === this.targetEditingLanguage.lang
    );
    if (UnitsValue) {
      UnitsValue.text = event;
    } else {
      surveyItem.units.push(
        new SurveyText(this.targetEditingLanguage.lang, event)
      );
    }
  }

  deleteOption(surveyItem: SurveyItem, index: number) {
    surveyItem.options = surveyItem.options
      .filter((_, i) => i != index)
      .map((value, i) => {
        value.id = String(i + 1);
        return value;
      });
  }

  searchFileExtension(filename: string) {
    const pos = filename.lastIndexOf(".");
    if (pos === -1) {
      // 拡張子がない場合は空文字を返す
      return "";
    } else {
      // 拡張子を返す
      return filename.slice(pos + 1);
    }
  }

  checkFileExtension(filename: string) {
    let ret = true;
    // 比較のため拡張子を小文字に変換
    const extension = this.searchFileExtension(filename).toLowerCase();
    // 対象の拡張子が許可されている拡張子の一覧であるallowFileExtensionにあるかを確認
    if (this.allowFileEextension.indexOf(extension) === -1) {
      ret = false;
    }
    return ret;
  }

  loadFileAsync(file: File) {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = () => {
        resolve(reader.result);
      };
      reader.onerror = reject;
      reader.readAsArrayBuffer(file);
    });
  }

  arrayBufferToString(arrayBuffer: ArrayBuffer, decoderType = "utf-8") {
    const decoder = new TextDecoder(decoderType);
    return decoder.decode(arrayBuffer);
  }

  async importFileContent(file: File) {
    let content = "";
    try {
      const buffer = await this.loadFileAsync(file);
      if (buffer instanceof ArrayBuffer) {
        content = this.arrayBufferToString(buffer);
      }
    } catch (error) {
      console.log(error);
    }
    return content;
  }

  validateJsonObject(jsonObj: JsonObject) {
    if (!this.isDefined(jsonObj.title)) return false;
    if (!this.isDefined(jsonObj.details)) return false;
    if (!this.isDefined(jsonObj.langs)) return false;
    if (!this.isDefined(jsonObj.qrPrefix)) return false;
    if (!this.isDefined(jsonObj.qrAnswerDate)) return false;
    if (!this.isDefined(jsonObj.surveyItems)) return false;
    return true;
  }

  importObjectAsJson(file: File) {
    // ファイルが指定されているのかを確認
    if (!this.isDefined(file)) {
      return;
    }
    // 拡張子の確認
    const res = this.checkFileExtension(file.name);
    if (!res) {
      alert("JSONファイルを選択してください。");
      return;
    }
    // ファイルデータの読み込み後の処理
    this.importFileContent(file).then(content => {
      // JSONファイルのデータ形式を確認
      let jsonObject: JsonObject;
      try {
        jsonObject = JSON.parse(content);
      } catch (error) {
        console.log(error);
        alert("JSONファイル内のデータ形式に誤りがあります。");
        return;
      }
      if (!this.validateJsonObject(jsonObject)) {
        alert("JSONファイル内のデータ形式に誤りがあります。");
        return;
      }
      // JSONファイルのデータ形式に問題がなければインスタンスを生成
      this.surveyForm = SurveyForm.getInstanceForJson(jsonObject);
      this.prevSurveyId = this.surveyForm.surveyId;

      this.surveyForm.title.map(val => {
        this.candidateLanguages.find(v => {
          if (val.lang == v.lang) {
            v.selected = true;
          }
        });
      });
    });
  }

  async downloadObjectAsJson() {
    const validationEditingLang = await this.executeValidationObserver();
    const validationSurveyItemNum = this.validateSurveyItemNum(this.surveyForm);
    const validationOtherLangs = this.validateSurveys(
      this.surveyForm,
      this.targetEditingLanguage.lang
    );
    // バリデーションチェックに問題がなければJSONを出力
    // 問題がある場合はダイアログでエラー表示
    if (
      validationEditingLang &&
      validationSurveyItemNum &&
      validationOtherLangs
    ) {
      this.surveyForm.hashCode = this.SurveyToHash(this.surveyForm, 5);
      const now = moment().format("YYYY/MM/DD HH:mm:ss");
      if (
        !this.surveyForm.createdDateTime ||
        this.surveyForm.surveyId !== this.prevSurveyId
      ) {
        this.surveyForm.createdDateTime = now;
      }
      this.surveyForm.updatedDateTime = now;
      const dataStr =
        "data:text/json;charset=utf-8," +
        encodeURIComponent(JSON.stringify(this.surveyForm));
      const downloadAnchorNode = document.createElement("a");
      downloadAnchorNode.setAttribute("href", dataStr);
      downloadAnchorNode.setAttribute(
        "download",
        this.surveyForm.surveyId + "_" + this.surveyForm.hashCode + ".json"
      );
      document.body.appendChild(downloadAnchorNode);
      downloadAnchorNode.click();
      downloadAnchorNode.remove();
    } else {
      this.showSurveyValidationErrorDialog = true;
    }
  }

  createUrl(surveyForm: SurveyForm) {
    const query: string[] = [
      `surveyId=${encodeURIComponent(surveyForm.surveyId)}`,
      `hashCode=${encodeURIComponent(surveyForm.hashCode)}`,
      `createdDateTime=${encodeURIComponent(surveyForm.createdDateTime)}`,
      `updatedDateTime=${encodeURIComponent(surveyForm.updatedDateTime)}`,
      `qrPrefix=${encodeURIComponent(surveyForm.qrPrefix)}`,
      `qrAnswerDate=${surveyForm.qrAnswerDate ? "1" : ""}`,
      `langs=${encodeURIComponent(
        JSON.stringify(surveyForm.langs.map(v => [v.lang, v.text]))
      )}`,
      `title=${encodeURIComponent(
        JSON.stringify(surveyForm.title.map(v => [v.lang, v.text]))
      )}`,
      `details=${encodeURIComponent(
        JSON.stringify(surveyForm.details.map(v => [v.lang, v.text]))
      )}`,
      `cols=${this.getCols(surveyForm.surveyItems)}`
    ];
    return `${location.protocol}//${location.hostname}${
      location.port ? ":" + location.port : ""
    }/#/delete?${query.join("&")}`;
  }

  getCols(surveyItems: SurveyItem[]) {
    return encodeURIComponent(
      JSON.stringify(
        surveyItems.map(item => [
          item.type,
          item.id,
          item.displayName.map(v => [v.lang, v.text]),
          item.rules.required ? "r" : "s",
          item.rules.max,
          item.options.map(opt => {
            const required = opt.isTextArea ? "r" : "s";
            const values = opt.value.map(v => [v.lang, v.text]);
            return [values, required].flat();
          }),
          item.units.map(v => [v.lang, v.text]),
          item.unitsRules ? "r" : "s"
        ])
      )
    );
  }

  SurveyToHash(survey: SurveyForm, len: number) {
    const text =
      JSON.stringify(survey.title) +
      JSON.stringify(survey.details) +
      JSON.stringify(survey.langs) +
      survey.qrPrefix +
      survey.qrAnswerDate +
      JSON.stringify(survey.surveyItems);
    const hash = crypto
      .createHash("md5")
      .update(text)
      .digest("hex");
    return hash.substr(0, len);
  }

  /**
   * アンケート項目有無のバリデーションチェック
   * @param surveyForm
   * @return バリデーション結果を返す
   * @private
   */
  validateSurveyItemNum(surveyForm: SurveyForm) {
    this.surveyItemNumValidationErrorMsg = "";
    const success = surveyForm.surveyItems.length > 0;
    if (!success) {
      this.errorValidateLanguages.add(this.targetEditingLanguage.text);
      this.surveyItemNumValidationErrorMsg = this.$t(
        "validations.surveyItemNumber"
      ).toString();
    }
    return success;
  }

  /**
   * 指定した言語でアンケート内の必須項目のバリデーションチェック
   * @param surveyForm
   * @return バリデーション結果を返す
   * @private
   */
  validateSurvey(surveyForm: SurveyForm, lang: languages) {
    const validateTitle = surveyForm.title
      .filter(t => t.lang === lang)
      .every(t => t.text !== "");
    const validateDisplayName = surveyForm.surveyItems
      .map(item => item.displayName)
      .flat()
      .filter(d => d.lang === lang)
      .every(v => v.text !== "");
    const validationOptionText = surveyForm.surveyItems
      .filter(
        item => item.type === "rd" || item.type === "cb" || item.type === "sl"
      )
      .map(item => item.options)
      .flat()
      .map(opt => opt.value)
      .flat()
      .filter(v => v.lang === lang)
      .every(v => v.text !== "");
    const validateUnitsText = surveyForm.surveyItems
      .filter(item => item.type === "nb")
      .map(item => item.units)
      .flat()
      .filter(d => d.lang === lang)
      .every(v => v.text !== "");
    return (
      validateTitle &&
      validateDisplayName &&
      validationOptionText &&
      validateUnitsText
    );
  }

  /**
   * 対象外の言語以外でアンケート内の必須項目のバリデーションチェックを実施
   * チェックでエラーの際は言語名をメンバ変数（errorValidateLanguages）に設定
   * @param surveyForm
   * @ignoreLang バリデーションチェック対象外とする言語
   * @return バリデーション結果を返す
   * @private
   */
  validateSurveys(surveyForm: SurveyForm, ignoreLang: languages) {
    const targetSurveyLang = surveyForm.langs.filter(
      v => v.lang !== ignoreLang
    );
    const validations = targetSurveyLang.map(v => {
      const res = this.validateSurvey(surveyForm, v.lang);
      if (!res) {
        this.errorValidateLanguages.add(v.text);
      }
      return res;
    });
    return validations.every(res => res === true);
  }

  /**
   * ValidationObserverタグ内のバリデーションチェックを実行
   * チェックでエラーの際は言語名をメンバ変数（errorValidateLanguages）に設定
   * ※編集選択中（表示中）の言語のバリデーションチェックのみ対応
   * @return バリデーション結果を返す
   * @private
   */
  async executeValidationObserver() {
    type ValidationObserverRef = InstanceType<typeof ValidationObserver>;
    const success = await (this.$refs
      .validationObserver as ValidationObserverRef).validate();
    if (!success) {
      this.errorValidateLanguages.add(this.targetEditingLanguage.text);
    }
    return success;
  }

  async previewSurvey(event: PointerEvent) {
    const validationEditingLang = await this.executeValidationObserver();
    const validationSurveyItemNum = this.validateSurveyItemNum(this.surveyForm);
    const validationOtherLangs = this.validateSurveys(
      this.surveyForm,
      this.targetEditingLanguage.lang
    );
    // バリデーションチェックに問題があれば画面遷移はせずにダイアログでエラー表示
    if (
      !(
        validationEditingLang &&
        validationSurveyItemNum &&
        validationOtherLangs
      )
    ) {
      event.preventDefault();
      this.showSurveyValidationErrorDialog = true;
    } else {
      this.surveyForm.hashCode = this.SurveyToHash(this.surveyForm, 5);
    }
  }
}
